
import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import * as bootstrap from "bootstrap";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);
import * as duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
import * as relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export class CommentElem {
    public idnum: number = 0;
    public idactu: number = 0;
    public author: string = "";
    public date!: Date;
    public contenu: string = "";
    public ip: string = "";
    public isdossier: boolean = false;
}

export class AddCommentApiRequest {
    public dccommenttexte: string = "";
    public idactu: number = 0;
    public idcommentcite: number = 0;
    public isdossier: boolean = false;
}

export class CommentApiViewModel {
    public numcomments: number = 0;
    public commenttab: CommentElem[] = [];
    }

    export default defineComponent({
        props: {
            p_idactu: { type: [Number], required: true },
            p_isdossier: { type: [String], required: true },
            p_numcomments: { type: [Number], required: true },
            p_last_page: { type: [Number], required: true },
            p_isuser: { type: [String], required: true },
            p_isadmin: { type: [String], required: true },
            view_actu_commentciter: { type: [String], required: true },
            view_actu_commentnociter: { type: [String], required: true },
            view_actu_btnmorecomments: { type: [String], required: true },
            viewactu_signalerpopup: { type: [String], required: true },
            view_actu_authorigin: { type: [String], required: true },
        },
        watch: {
            p_idactu(newValue: number) {
                this.idactu = newValue;
            },
            p_isdossier(newValue: string) {
                this.isdossier = (newValue == 'true');
            },
            p_numcomments(newValue: number) {
                this.numcomments = newValue;
            },
            p_last_page(newValue: number) {
                this.last_page = newValue;
            }

        },

        data() {
            return {
                idactu: 0,
                isdossier:false,
                showcomments: false,
                postcomment: "",
                postactu: [] as CommentElem[],
                printfirstpage: true,
                idcommentcite: 0,
                dcloadingnews: false,
                lancurrent: "fr",
                numcomments: 0,
                last_page: 1,
                dayjs: null as any,
                isuser: false,
                isadmin: false,
                smileys: [] as number[]
            };
        },

        methods: {
            ShowComments(event: any) {
                event.preventDefault();
                this.showcomments = !this.showcomments;
                if (this.showcomments) {
                    setTimeout(() => {
                        let elem = $("#dcpostcommentblock").offset();
                        if (elem != null)
                            $('html, body').animate({ scrollTop: elem.top - 90 }, 200);
                    }, 100);
                }

                return true;
            },

            getlistSmileys() {
                for (let code: number = 0x1F600; code < 0x1F64F; code++) {
                    this.smileys.push(code);
                }
            },

            PrintSmiley(code: number): string {
                try {
                    return String.fromCodePoint(code);
                }
                catch (e) {
                    return '';
                }
            },

            AddSmiley(code: number) {
                try {
                    this.postcomment += String.fromCodePoint(code);
                    return false;
                }
                catch (e) {
                    console.log('err');
                    return false;
                }
              
            },

            insertTextAtCursor(el:any,comment:string, text:string): string {
                var val = comment, endIndex, range;
                if(typeof el.selectionStart != "undefined" && typeof el.selectionEnd != "undefined") {
                    endIndex = el.selectionEnd;
                    comment = val.slice(0, el.selectionStart) + text + val.slice(endIndex);
                    el.selectionStart = el.selectionEnd = endIndex + text.length;
                    return comment;
                }
                return "";
            },

            insertSmiley(smiley: string) {
                this.postcomment = this.insertTextAtCursor((this.$refs as any).commenttext, this.postcomment, smiley);
            },

            CiterCommentaire(event: any, idcommentcite: number) {
                event.preventDefault();
                this.idcommentcite = idcommentcite;
                this.showcomments = true;
                setTimeout(() => {
                    let elem = $("#dcpostcommentblock").offset();
                    if (elem != null)
                        $('html, body').animate({ scrollTop: elem.top - 90 }, 200);
                }, 100);
            },

            SansCiterCommentaire(event: any) {
                event.preventDefault();
                this.idcommentcite = 0;
                this.showcomments = true;
                setTimeout(() => {
                    let elem = $("#dcpostcommentblock").offset();
                    if (elem != null)
                        $('html, body').animate({ scrollTop: elem.top - 90 }, 200);
                }, 100);
            },

            async AddComment(event: any) {
                event.preventDefault();
                let self = this;
                const url = "/api/v1.0/comments/AddComment";
                let postdata: AddCommentApiRequest = new AddCommentApiRequest();
                postdata.isdossier = this.isdossier;
                postdata.idactu = this.idactu;
                postdata.dccommenttexte = this.postcomment;
                postdata.idcommentcite = this.idcommentcite;
                const response: AxiosResponse<boolean> = await axios.post<boolean>(url, postdata);
                if (response !== null && response.data) {
                    self.printfirstpage = false;
                    self.last_page = 1;
                    self.postcomment = "";
                    const url = `/api/v1.0/comments/AfficherComments?isdossier=${self.isdossier}&id=${self.idactu}&pagecomment=${self.last_page.toString()}`
                    const response2: AxiosResponse<CommentApiViewModel> = await axios.get<CommentApiViewModel>(url);
                    if (response2 !== null && response2.data !== null && response2.data.commenttab !== null) {
                        self.postactu = response2.data.commenttab;
                        self.numcomments = response2.data.numcomments;
                        self.last_page++;
                    }
                }
            },

            async MoreComments(event: any) {
                if (event != null)
                    event.preventDefault();
                let self = this;
                const url = `/api/v1.0/comments/AfficherComments?isdossier=${self.isdossier}&id=${this.idactu}&pagecomment=${this.last_page.toString()}`
                const response: AxiosResponse<CommentApiViewModel> = await axios.get<CommentApiViewModel>(url);
                if (response !== null && response.data !== null && response.data.commenttab !== null) {
                    self.postactu = self.postactu.concat(response.data.commenttab);
                    self.numcomments = response.data.numcomments;
                    self.last_page++;
                }
            },

            async DeleteComment(idcomment: number) {
                let choice = confirm("Etes vous sur de supprimer ce commentaire?");
                if (!choice)
                    return;
                let self = this;
                const url = `/api/v1.0/comments/DeleteComment?idcomment=${idcomment}`;
                const response: AxiosResponse<boolean> = await axios.delete<boolean>(url);
                if (response !== null) {
                    if (response.data)
                        location.reload();
                }
            },

            async SignalerComment(event: any, idcomment: number, signalerdesc: string) {
                event.preventDefault();
                let self = this;
                const url = `/api/v1.0/comments/SignalerComment?idcomment=${idcomment}`;
                const response: AxiosResponse<boolean> = await axios.post<boolean>(url);
                if (response !== null) {
                    if (response.data) {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            customClass: {
                                container: 'dctoastcontainer'
                            },
                            icon: 'success',
                            title: signalerdesc,
                            showConfirmButton: false,
                            timer: 2500
                        });
                    }
                }
            },

            FilterComment(html: string) {
                /* let filterhtml = sanitizeHtml(html, {
                     allowedTags: ['b', 'i', 'em','br', 'strong', 'a']
                 });*/
                let dom = new DOMParser()
                    .parseFromString(html, 'text/html');
                let childs: HTMLCollectionOf<Element> = dom.body.getElementsByTagName("*");
                const allowedTags = ['b', 'i', 'em', 'br', 'strong', 'a', 'blockquote','div'];
                for (let i = 0; i < childs.length; i++) {
                    const namenode = childs[i].nodeName.toLowerCase();
                    if (namenode == "a")
                        childs[i].setAttribute("rel", "nofollow");
                    if (allowedTags.indexOf(namenode) == -1) {
                        childs[i].parentNode?.removeChild(childs[i]);

                    }
                }
                html = dom.documentElement.innerHTML;
                html = html.split("\n").join("</br>");
                return html;
            },

            DCLoginOpenLoginModal() {

                let elt = document.getElementById('dc_logindialog');
                if (elt !== null) {
                    let modal = new bootstrap.Modal(elt, {});
                    modal.show();
                }
            }
        },

    created() {
        this.dayjs = dayjs;
        this.isuser = (this.p_isuser == 'true');
        this.isadmin = (this.p_isadmin == 'true');
        this.idactu = this.p_idactu;
        this.isdossier = (this.p_isdossier == 'true');
        this.numcomments = this.p_numcomments;
        this.last_page = this.p_last_page;
    },

        async mounted() {
            var self = this;
        await this.MoreComments(null);
        this.getlistSmileys();
      
        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl: any) {
                // Use event delegation to handle clicks on smiley links
             
            let popover = new bootstrap.Popover(popoverTriggerEl, {
                container: 'body',
                html: true,
                content: function () {
                    const elt = document.getElementById('smiley-content');
                    if (elt == null)
                        return "";

                    elt.innerHTML = ''; // Clear existing content

                    self.smileys.forEach(function (smiley: number) {
                        var link = document.createElement('a');
                        link.href = '#';
                        link.classList.add('smiley-link');
                        link.textContent = self.PrintSmiley(smiley);
                        elt.appendChild(link);
                    });

                    return elt.innerHTML;
                }
            });

            return popover;
        });
            document.addEventListener('click', function (event: any) {
                if (event.target.classList.contains('smiley-link')) {
                    event.preventDefault();
                    self.insertSmiley(event.target.textContent);
                    event.stopPropagation();
                    $('[data-bs-toggle="popover"]').popover('hide');
                }

                if ($(event.target).parent().find('[data-bs-toggle="popover"]').length > 0) {
                    $('[data-bs-toggle="popover"]').popover('hide');
                }
            });
        }
});
